export default __webpack_public_path__ + "static/media/Pin.b80df2eb.svg";